<template>
    <v-switch
        v-model="modelValue"
        base-color="gray-300"
        class="custom-switch"
        color="primary"
        density="compact"
        flat
        hide-details
        inset
        :ripple="false"
        @change="emit('change', modelValue)">
        <template #label>
            <span class="tw-text-sm tw-font-medium tw-tracking-normal tw-text-dark">
                <slot></slot>
            </span>
        </template>
    </v-switch>
</template>

<script setup lang="ts">
    const modelValue = defineModel({
        type: Boolean,
        default: false,
    });
    const emit = defineEmits(['change']);
</script>

<style lang="scss">
    .custom-switch {
        width: 100%;
        .v-label--clickable {
            flex-grow: 1;
        }
        .v-selection-control__wrapper {
            order: 2;
        }
    }
</style>
